import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppLocalStorage, } from "../../hook/localStorage";
import BackButton from "../BackButton/BackButton";
import styles from "./Header.module.css";
import { useCheckout } from "../../context/CheckoutContext";

type IHeaderProps = {
  path?: string;
  screen?: string;
}

export function Header({ path, screen}: IHeaderProps) {
  const { app } = useAppLocalStorage();
  const { resetContext } = useCheckout();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const navigateToHome = () => {
    if (location.pathname.includes('/checkout-pagamento-aprovado')) {
      resetContext();
    }
    navigate(params.slug ? `/${params.slug}`: '/')
  }

  return (
    <div className={`${styles.header} ${screen === 'pix' && styles.headerPix}`}>
      <div className={styles.logoName}>
        <div
          className={styles.logoContainer}
          style={{ backgroundColor: app?.primaryColor}}
          onClick ={navigateToHome}
        >
          <img
            className={app?.logo ? styles.logoIcon : styles.logoYellyIcon}
            alt=""
            src={app?.logo || "/logo-yelly6.svg"}
          />
        </div>
        {app?.name &&
          <span
            title={app.name}
            className={styles.name}
            style={{color: app?.primaryColor}}
          >
            {app.name}
          </span>
        }
      </div>
      {path && path !== "none" &&
        <BackButton path={path} />
      }
    </div>
  )
}